let Proveedor = {
    Id: Number,
    RazonSocial: String,
    FactoresQueSuman: [],
    SubtotalP: Number,
    factoresQueRestan: [],
    Subtotal: Number,
    Total: Number,
    UltimaActualizacion: String
};

export default Proveedor;